module.exports = "<div class=\"block-buttons\">\r\n  <button (click)=\"showScanner()\" class=\"m-btn m-btn-primary margin-lr-1\">Open Scanner</button>\r\n  <button (click)=\"showUploadFile()\" class=\"m-btn m-btn-secondary margin-lr-1\">Upload File</button>\r\n</div>\r\n\r\n<app-scanner *ngIf=\"showScannerView\" [barcodeFormat]=\"barcodeFormat\"></app-scanner>\r\n<app-upload-img *ngIf=\"showUploadFileView\"></app-upload-img>"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/barcode-scanner/barcode-scanner.component.html
// module id = 2587
// module chunks = 66